import './target-selection-mail.ajscss';

import { TransferTarget } from '@agent/core/contact/transfer/models/transfer';
import { hasChange } from '@commons/util/helper/helper';
import { copy, IChangesObject, IComponentController, IComponentOptions } from 'angular';
import { i18n } from 'i18next';

import templateUrl from './target-selection-mail.html';

const MODULE_NAME = 'transferTargetSelectionMail';

class TransferTargetSelectionMailCtrl implements IComponentController {
  public name = MODULE_NAME;

  // binding
  public eventTargetTypeChange: Function;
  public targetType: TransferTarget;

  // internal properties
  public targetTypes: TransferTarget[] = [];

  constructor(private readonly $i18next: i18n) {}

  $onInit() {
    // target available to transfer
    this.targetTypes.push(TransferTarget.SKILL);
    this.targetTypes.push(TransferTarget.TEAM);
    this.targetTypes.push(TransferTarget.AGENT);
    this.targetTypes.push(TransferTarget.CORRESPONDENT);
    this.targetTypes.push(TransferTarget.FREE_NUMBER);
    // initialize target type to first value of types available
    this.targetType = this.targetTypes[0];
    this.onTargetTypeChange();
  }

  $onChanges(changesObj: { [property: string]: IChangesObject }) {
    // targetType changed
    if (hasChange(changesObj['targetType'])) {
      this.targetType = copy(changesObj['targetType'].currentValue);
    }
  }

  onTargetTypeChange(): void {
    this.eventTargetTypeChange({ $event: { targetType: this.targetType } });
  }

  getTargetLabel(target: TransferTarget): string {
    let targetKey = `${TransferTarget[target].toLowerCase()}_target`;
    return this.$i18next.t('agent:contact.workspace.mail.transfer.' + targetKey);
  }
}

export class TransferTargetSelectionMail implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    targetType: '<',
    eventTargetTypeChange: '&',
  };
  controller = ['$i18next', TransferTargetSelectionMailCtrl];
}

export default MODULE_NAME;
